import cx from 'classnames';
import Image from 'next/image';

import {Text} from '#component/base';
import {Transition} from '#component/util';
import {sprinkles} from '#style/sprinkles';

import * as css from './HealthFactorSummary.css';

interface HealthFactorSummaryProps extends React.HTMLProps<HTMLInputElement> {
  imageUrl?: string;
  title: string;
  question: string;
  answer?: string;
  recommendedAnswer: string;
  impactLevel?: string;
  meetsRequirement?: boolean;
  emergingResearch: boolean;
}

export const HealthFactorSummary = ({
  id,
  className,
  imageUrl,
  impactLevel,
  title,
  question,
  answer,
  recommendedAnswer,
  meetsRequirement,
  emergingResearch,
}: HealthFactorSummaryProps) => (
  <Transition appear className={cx(css.root, className)} id={id} show>
    <div className={css.content}>
      <div className={css.circleContainer}>
        <Transition.Child className={css.bgCircle} />
        <Transition.Child className={css.imageCircle}>
          {imageUrl && <Image objectFit="cover" alt="" aria-hidden layout="fill" src={imageUrl} />}
        </Transition.Child>
      </div>

      <div className={css.infoStyles}>
        <Text variant="heading1" as="h1" color="burgundy" className={sprinkles({mB: [16]})}>
          {title}
        </Text>
        {!emergingResearch && (
          <Text variant="bodyLarge" color="burgundy">
            {`${
              meetsRequirement ? 'Keep this up' : 'Start doing this'
            } to have a ${impactLevel?.toLowerCase()} impact on your TallyAge™`}
          </Text>
        )}
        {!emergingResearch && (
          <>
            <div className={cx(css.dividerStyles, sprinkles({mY: 32}))} />
            <Text variant="heading4" color="doveGray" className={sprinkles({mB: [8]})}>
              Lifestyle Survey question
            </Text>
            <Text variant="bodyLarge" color="doveGray" className={sprinkles({mB: [40]})}>
              {question}
            </Text>
            <Text variant="heading4" color="doveGray" className={sprinkles({mB: [10]})}>
              We recommend
            </Text>
            <Text variant="heading2" color="doveGray" className={sprinkles({mB: [8]})}>
              {recommendedAnswer}
            </Text>
            <Text color="doveGray">{`You answered: ${answer}`}</Text>
          </>
        )}
      </div>
    </div>
  </Transition>
);
